import PropTypes from 'prop-types';
import React from 'react';
import {parseLocation} from 'parse-address';
import {injectIntl, intlShape} from 'react-intl';

const longCountryCodes = {
  CA: 'CAN',
  US: 'USA',
};

class AddressComplete extends React.Component {
  static defaultProps = {
    editMode: true,
    delay: 0,
  };

  static displayName = 'AddressComplete';

  static propTypes = {
    delay: PropTypes.number,
    dirtied: PropTypes.number,
    editMode: PropTypes.bool,
    group: PropTypes.object,
    id: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    required: PropTypes.bool,
    setVerified: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
  };

  state = {
    address: this.props.value,
    verified: null,
    correct: true,
  };

  componentDidMount() {
    this.mounted = true;

    if (this.props.group) {
      this.props.group.addComponent(this);
    }

    // Push address complete initialiations to bottom of stack so it doesn't block execution and page rendering
    // Space them out as well incase there are a lot
    setTimeout(() => {
      if (!this.mounted) {
        return;
      }

      const fields = [
        {element: this.props.id, field: 'Label'},
      ];

      const options = {
        key: 'UU89-DF83-DE28-AY83',
        autoSearch: true,
        setCountryByIP: false,
        culture: (this.props.intl.locale || 'en-US').toLowerCase(),
        // WARNING: Undocumented API, this may break
        countries: {defaultCode: longCountryCodes[this.props.country] || 'USA'},
      };

      const control = new window.pca.Address(fields, options);

      control.listen('populate', (address) => {
        this.setState({
          address: address.Label.replace(/\r\n|\n|\r/g, ', '),
          correct: true,
          verified: address,
        });
        if (this.props.setVerified) {
          this.props.setVerified(true);
        }

        if (this.props.dataChanged) {
          setTimeout(() => this.props.dataChanged({value: this.getValue(), key: 'address'}), 100);
        }
      });


      this.control = control;

    }, 0 + this.props.delay);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value || nextProps.dirtied !== this.props.dirtied) {
      this.setState({
        address: nextProps.value,
      });
    }
  }

  componentWillUnmount() {
    if (this.props.group) {
      this.props.group.removeComponent(this);
    }
    if (this.control && this.control.destroy) {
      this.control.destroy();
    }
    this.control = null;
    this.mounted = false;
  }

  onChange = (e) => {
    let correct = this.state.correct;

    if (!correct && e.target.value && this.props.required) {
      this.setState({correct: true});
    }
    this.setState({
      address: e.target.value,
      correct,
    });
    if (this.props.setVerified) {
      this.props.setVerified(false);
    }

    if (this.props.dataChanged) {
      setTimeout(() => this.props.dataChanged({value: this.getValue(), key: 'address'}), 100);
    }
  };

  onFocus = () => {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  getValue = () => {
    if (!this.state.verified || this.state.address !== this.state.verified.Label.replace(/\r\n|\n|\r/g, ', ')) {
      let newAddress = parseLocation(this.state.address);

      return {
        address1: [newAddress.number, newAddress.prefix, newAddress.street, newAddress.type, newAddress.suffix]
          .filter(x => !!x).join(' '),
        address2: [newAddress.sec_unit_type, newAddress.sec_unit_num]
          .filter(x => !!x).join(' '),
        city: newAddress.city,
        state: newAddress.state,
        zip: newAddress.zip,
        country: newAddress.country,
        addressCompleteID: null,
      };
    }

    return {
      address1: this.state.verified.Line1,
      address2: this.state.verified.Line2,
      city: this.state.verified.City,
      state: this.state.verified.ProvinceCode,
      zip: this.state.verified.PostalCode,
      country: this.state.verified.CountryIso2,
      addressCompleteID: this.state.verified.Id,
    };
  };

  focus = () => {
    this.input.focus();
  };

  reset = () => {
    this.setState({
      address: this.props.value,
      verified: null,
      correct: true,
    });
  };

  validate = () => {
    if (this.props.required && !this.state.address) {
      this.setState({correct: false});
      return false;
    }
    this.setState({correct: true});
    return true;
  };

  render() {
    return <div>
      {this.props.editMode ? <input id={this.props.id}
                                    type='text'
                                    ref={f => this.input = f}
                                    className={'form-control' + (!this.state.correct ? ' error' : '')}
                                    onBlur={this.props.onBlur}
                                    onFocus={this.onFocus}
                                    onChange={this.onChange}
                                    value={this.state.address}/> :
      <div className={'form-control-static' + (!this.state.correct ? ' error' : '')}>
        {this.state.address}
      </div>}
    </div>;
  }
}

export default injectIntl(AddressComplete, {withRef: true});
